export const config = {
  upload: {
    supportedVideoFileExtensions: [
      'video/x-msvideo',
      'video/x-ms-wmv',
      'video/quicktime',
      'video/x-mpeg',
      'video/x-mpeq2a',
      'video/mpeg',
      'video/x-flv',
      'application/mxf',
      'model/vnd.mts',
      'video/x-m4v',
      'video/3gpp',
      'video/mp4',
      'video/webm',
      'video/avi',
    ],
    supportedAudioFileExtensions: [
      'audio/aac',
      'audio/x-caf',
      'audio/caf',
      'audio/mpeg',
      'audio/ogg',
      'audio/x-wav',
      'audio/wav',
    ],
  },

  /**
   * Check interval (in seconds) for token expiry.
   * @var {number} ctTokenCheckInterval
   */
  ctTokenCheckInterval: 30,

  /**
   * In local development, if true will load main sass build from
   * localhost ct-admin.
   *
   * Most of the time we'll need local build included into
   *  `on-save > rebuild > stream` dev flow.
   */
  mainCssRemoteInLocalDev: false,
};
